import React from 'react';
import {Chip, Stack, Typography} from '@mui/material';
import {formatIcrClassification, formatIcrDueDateDisplay} from '../icrHeaderFormat';
import IcrPriorityLabel from './IcrPriorityLabel';

/**
 * Upper-right ICR header stack: classification, priority, due date.
 */
export default function IcrHeaderMeta({
    classification,
    priority,
    dueDate,
    workflowStatus,
}) {
    const due = formatIcrDueDateDisplay(dueDate);

    return (
        <Stack alignItems={{xs: 'flex-start', sm: 'flex-end'}} spacing={0.75} flexShrink={0}>
            {workflowStatus && workflowStatus !== 'Active' && (
                <Chip
                    label={workflowStatus}
                    color={workflowStatus === 'Pending Approval' ? 'warning' : 'default'}
                    size="small"
                />
            )}
            <Typography variant="body2" color="text.secondary" sx={{fontWeight: 600}}>
                {formatIcrClassification(classification)}
            </Typography>
            <IcrPriorityLabel priority={priority}/>
            <Typography
                variant="body2"
                color={due.isPast ? 'error.main' : 'text.secondary'}
                sx={{fontWeight: due.isPast ? 600 : 400}}
            >
                {due.label}
            </Typography>
        </Stack>
    );
}
